import styled, { css } from 'styled-components';
import {
  GridCardPosition,
  GridCardVariant,
  TradeState
} from '../../../_shared/types/trade';
import { BidStatus } from '../../../_shared/types/auction';

const hasBidBorders = bidStatus =>
  [BidStatus.topBidder, BidStatus.outbid, BidStatus.proxy].includes(bidStatus);

const StyledTradeCardEventContainerVariants = {
  [GridCardPosition.LEFT]: css`
    border-left: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    border-radius: 3px 0 0 3px;
  `,
  [GridCardPosition.BETWEEN]: css`
    padding: ${({ isSelected, bidStatus }) =>
      isSelected || hasBidBorders(bidStatus) ? '6px 5px' : '10px 9px'};
  `,
  [GridCardPosition.RIGHT]: css`
    border-right: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    border-radius: 0 3px 3px 0;
  `
};

const StyledTradeCardEventStartContainerVariants = {
  [GridCardPosition.BETWEEN]: css`
    padding-left: 7px;
  `,
  [GridCardPosition.RIGHT]: css`
    border-right: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    border-radius: 0 3px 3px 0;
    padding-left: 7px;
  `
};

const StyledTradeCardEventEndContainerVariants = {
  [GridCardPosition.LEFT]: css`
    border-left: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    border-radius: 3px 0 0 3px;
  `,
  [GridCardPosition.BETWEEN]: css`
    padding-right: 3px;
  `,
  [GridCardPosition.RIGHT]: css`
    padding-right: 0;
  `
};

const StyledTradeCardNonEventContainerVariants = {
  [GridCardPosition.LEFT]: css`
    padding-left: ${({ isSelected, bidStatus }) =>
      isSelected || hasBidBorders(bidStatus) ? 0 : 4}px;
    padding-right: ${({ isSelected, bidStatus }) =>
      isSelected || hasBidBorders(bidStatus) ? 5 : 9}px;
  `,
  [GridCardPosition.BETWEEN]: css`
    padding: ${({ isSelected, bidStatus }) =>
      isSelected || hasBidBorders(bidStatus) ? '0 2.5px' : '4px 6.5px'};
  `,
  [GridCardPosition.RIGHT]: css`
    padding-left: ${({ isSelected, bidStatus }) =>
      isSelected || hasBidBorders(bidStatus) ? 5 : 9}px;
    padding-right: ${({ isSelected, bidStatus }) =>
      isSelected || hasBidBorders(bidStatus) ? 0 : 4}px;
  `
};

const StyledTradeCardContainerVariants = {
  [GridCardVariant.EVENT_TRADE]: css`
    padding: ${({ isSelected, bidStatus }) =>
      isSelected || hasBidBorders(bidStatus) ? '6px 4px' : '10px 8px'};
    background-color: ${({ theme }) => theme.COLORS.BASE};
    border-top: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    ${({ position }) => StyledTradeCardEventContainerVariants[position]}
  `,
  [GridCardVariant.EVENT_START]: css`
    padding: 0;
    ${({ position }) => StyledTradeCardEventStartContainerVariants[position]}
  `,
  [GridCardVariant.EVENT_END]: css`
    padding: 0 7px 0 0;
    ${({ position }) => StyledTradeCardEventEndContainerVariants[position]}
  `,
  [GridCardVariant.NON_EVENT_TRADE]: css`
    ${({ position }) => StyledTradeCardNonEventContainerVariants[position]}
  `
};

export const StyledTradeCardVariants = {
  [BidStatus.topBidder]: css`
    border: 4px solid ${({ theme }) => theme.COLORS.LA_PALMA};
    box-shadow: ${({ isSelected }) =>
      isSelected ? '0 1px 9px rgba(0, 0, 0, 0.6)' : 'none'};
  `,
  [BidStatus.outbid]: css`
    border: 4px solid ${({ theme }) => theme.COLORS.MONZA};
    box-shadow: ${({ isSelected }) =>
      isSelected ? '0 1px 9px rgba(0, 0, 0, 0.6)' : 'none'};
  `,
  [BidStatus.proxy]: css`
    border: 4px solid ${({ theme }) => theme.COLORS.LA_PALMA};
    box-shadow: ${({ isSelected }) =>
      isSelected ? '0 1px 9px rgba(0, 0, 0, 0.6)' : 'none'};
  `,
  selected: css`
    border: 4px solid ${({ theme }) => theme.COLORS.TERTIARY};
    box-shadow: 0 1px 9px rgba(0, 0, 0, 0.5);
  `
};

export const StyledTradeCardContainer = styled.div`
  position: relative;
  width: 237px;
  height: ${({ tradeState }) =>
    tradeState === TradeState.active ? 287 : 258}px;
  padding: ${({ isSelected, bidStatus }) =>
    isSelected || hasBidBorders(bidStatus) ? '0 8px' : '4px 9px'};
  margin: 5px 0;
  ${({ variant }) => StyledTradeCardContainerVariants[variant]}
`;

export const StyledTradeCard = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  cursor: pointer;
  ${({ isSelected }) => isSelected && StyledTradeCardVariants.selected};
  ${({ variant }) => StyledTradeCardVariants[variant]}
`;
